module.exports = __webpack_public_path__ + "img/fixed-ship-bg.2a59517d.svg";